/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoVehicleBasicBaseResponse as LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse } from '../../models/Limelight/Babylon/DataObjects/DTO/dto-vehicle-basic-base-response';

export interface V3PublicApplicationVehicleApplicationIdVehicleLookupGet$Json$Params {
  plateVin?: string;
  applicationId: string;
}

export function v3PublicApplicationVehicleApplicationIdVehicleLookupGet$Json(http: HttpClient, rootUrl: string, params: V3PublicApplicationVehicleApplicationIdVehicleLookupGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3PublicApplicationVehicleApplicationIdVehicleLookupGet$Json.PATH, 'get');
  if (params) {
    rb.query('plateVin', params.plateVin, {});
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>;
    })
  );
}

v3PublicApplicationVehicleApplicationIdVehicleLookupGet$Json.PATH = '/v3/public/application/vehicle/{applicationId}/vehicleLookup';
